import { navigate } from "gatsby"

import { DLClickEvent } from "../DLEvents/DLClickEvent"
import scrollToPersonalForm from "../../scrollToPersonalForm"
import scrollToCalc from "../../scrollToCalc"

const handleClickBanner = (
  name: "sticky" | "click_cta",
  withoutScroll = false
) => {
  DLClickEvent({ name, placement: "banner" })
  if (withoutScroll) return
  scrollToPersonalForm()
}

const handleClickBannerWithScrollToCalc = (name: "sticky" | "click_cta") => {
  DLClickEvent({ name, placement: "banner" })
  scrollToCalc()
}

const handleClickHeaderButton = (name: "sticky" | "click_cta") => {
  DLClickEvent({ name, placement: "header" })
  scrollToPersonalForm()
}

const handleClickHeaderButtonWithNavigate = (
  name: "sticky" | "click_cta",
  withScrollToForm = false
) => {
  DLClickEvent({ name, placement: "header" })
  return withScrollToForm
    ? scrollToPersonalForm()
    : navigate("https://anketa.sovcombank.ru/")
}

export {
  handleClickBanner,
  handleClickBannerWithScrollToCalc,
  handleClickHeaderButton,
  handleClickHeaderButtonWithNavigate,
}
